import { useState, Component } from "react";
import { AnimatePresence } from "framer-motion";
import "@/App.css";
import "@/index.css";
import Cover from "@/components/Cover";
import BookShell from "@/components/BookShell";

class ErrorBoundary extends Component {
    state = { err: false };
    static getDerivedStateFromError() {
        return { err: true };
    }
    render() {
        if (this.state.err) {
            return (
                <div className="h-screen flex flex-col items-center justify-center gap-4 desk-bg text-center px-6">
                    <p className="f-display text-2xl text-[#d9bc8a]">Il tomo si è richiuso di colpo.</p>
                    <button className="btn-brass" onClick={() => window.location.reload()} data-testid="error-reload-button">
                        Riapri il tomo
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    const [phase, setPhase] = useState("closed"); // closed -> opening -> open

    return (
        <ErrorBoundary>
            <AnimatePresence>
                {phase !== "open" && (
                    <Cover key="cover" onOpenStart={() => setPhase("opening")} onFinished={() => setPhase("open")} />
                )}
            </AnimatePresence>
            {phase !== "closed" && <BookShell />}
        </ErrorBoundary>
    );
}

export default App;
